import TablePaginationCore, { LabelDisplayedRowsArgs, TablePaginationProps } from '@material-ui/core/TablePagination';
import React, { memo, useCallback } from 'react';
import { IPaginationParams } from 'src/models/interfaces/pagination';

type IProps = Partial<Omit<TablePaginationProps, 'onChange'>> & {
  disabled?: boolean;
  paginationParams: IPaginationParams;
  total: number;
  onChange: (params: { page?: number; pageSize?: number }) => void;
  colspan?: number;
};

const TablePagination = memo(({
  disabled,
  total,
  paginationParams: { page, pageSize },
  onChange,
  ...extra
}: IProps) => {
  const handleChangePage = useCallback(
    (event: any, page: number) => {
      onChange({ page });
    },
    [onChange]
  );

  const handleChangeRowsPerPage = useCallback(
    (event: any) => {
      onChange({ pageSize: Number(event.target.value) });
    },
    [onChange]
  );

  const labelDisplayedRows = useCallback(
    ({ from, to, count }: LabelDisplayedRowsArgs) => `${from}-${to} de ${count}`,
    []
  );

  return (
    <TablePaginationCore
      labelRowsPerPage='items'
      labelDisplayedRows={labelDisplayedRows}
      rowsPerPageOptions={[10, 25, 50]}
      component={'td' as any}
      {...extra}
      count={total}
      rowsPerPage={pageSize}
      page={page}
      onChangeRowsPerPage={handleChangeRowsPerPage}
      onChangePage={handleChangePage}
    />
  );
});

export default TablePagination;
